import React from "react";
import { Breadcrumb } from "antd";
import "./customBreadcrumb.css";

const CustomBreadcrumb = ({ items = [] }) => {
  return (
    <Breadcrumb  className="custom-breadcrumb" items={items} />
  );
};

export default CustomBreadcrumb;
